module.exports = __webpack_public_path__ + "img/support1.9d5edfba.png";